module.exports = __webpack_public_path__ + "img/9-preview.6d53afc7.jpg";